import _, { isEmpty } from 'lodash';
//import moment from 'moment';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { withStyles } from '@material-ui/core/styles';

import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';

import PricingRequestsContainer from '../../containers/retailPricing/PricingRequests';
import AuthUserContainer from '../../containers/AuthUser';
import Popover from '@material-ui/core/Popover';

import { getSharedStyles } from '../../themes';
import EnhancedTable from '../../components/table/EnhancedTable';
import Button from '@material-ui/core/Button';
import { Typography } from '@material-ui/core';

import GreenChecked from '../../images/icons/greenChecked.svg';
import YellowWarning from '../../images/icons/yellowWarning.svg';
import ErrorIcon from '../../images/icons/error.svg';

import invoiceIcon from '../../images/invoicePdf.svg';

import TriageIcon from '@material-ui/icons/SmsFailed';
import PendingIcon from '@material-ui/icons/AccessTime';
import InvalidIcon from '@material-ui/icons/DeleteForever';
import PriceGoodIcon from '@material-ui/icons/AttachMoney';
import orange from '@material-ui/core/colors/orange';
import blue from '@material-ui/core/colors/blue';

//Tabs
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import SwipeableViews from 'react-swipeable-views';
import { sortTable } from '../../libs/utility';
import { freshnessToColorHsl } from './helper';
import UnknownPricingRepliesDialog from '../../components/Dialogs/UnknownPricingRepliesDialog';
import ConfirmInvalidatePricingRequest from '../../components/Dialogs/ConfirmInvalidatePricingRequest';
import PriceSettingsDialog from '../../components/Dialogs/PriceSettingsDialog';
import TestMultiSmsDialog from '../../components/Dialogs/TestMultiSmsDialog';

const DAYS_BACK_TO_SEARCH = 31;

const styles = (theme) => ({
	...getSharedStyles(theme),
	enterButton: {
		color: blue[500],
		verticalAlign: 'middle',
		padding: '8px 10px',
		marginRight: '5px',
	},
	triageButton: {
		color: orange[500],
		verticalAlign: 'middle',
		padding: '8px 10px',
	},
	docContainer: {
		position: 'absolute',
	},
	addButton: {
		verticalAlign: 'middle',
		textDecoration: 'none',
		marginBottom: 10,
		borderRadius: 100,
	},
	greenCheckedIconSmall: {
		backgroundImage: `url('${GreenChecked}')`,
		display: 'inline-block',
		width: 16,
		height: 16,
		backgroundPosition: 'center',
		backgroundSize: 'cover',
		verticalAlign: 'middle',
		marginRight: 2,
	},
	warningIconSmall: {
		backgroundImage: `url('${YellowWarning}')`,
		display: 'inline-block',
		width: 22,
		height: 22,
		backgroundPosition: 'center',
		backgroundSize: 'cover',
		verticalAlign: 'middle',
		marginRight: 2,
	},
	errorIconSmall: {
		backgroundImage: `url('${ErrorIcon}')`,
		display: 'inline-block',
		width: 18,
		height: 18,
		backgroundPosition: 'center',
		backgroundSize: 'cover',
		verticalAlign: 'middle',
		marginRight: 2,
	},
	invoiceIcon: {
		display: 'inline-block',
		width: 40,
		height: 48,
		backgroundImage: `url('${invoiceIcon}')`,
		backgroundPosition: 'center',
		backgroundSize: 'cover',
		verticalAlign: 'middle',
		position: 'relative',
		flexShrink: 0,
		cursor: 'pointer',
	},
	replyMessage: {
		lineHeight: 1.4,
		backgroundColor: '#e5e5e5',
		borderRadius: 10,
		padding: '8px 12px',
		color: '#222',
		position: 'relative',
	},
	replyStatus: {
		position: 'absolute',
		right: 7,
		top: 7,
		opacity: 0.9,
	},
	replyDate: {
		fontSize: 13,
		color: '#666',
		textAlign: 'left',
		marginBottom: 2,
		marginTop: 10,
		marginLeft: 3,
	},
	popover: {
		pointerEvents: 'none',
	},
	commentsContainer: {
		padding: 7,
		display: 'inline-block',
		fontSize: '90%',
		maxWidth: '400px',
	},
	freshnessColor: {
		height: 12,
		width: 12,
		border: `.5px solid #aaa`,
		borderRadius: 2,
		display: 'inline-block',
		marginRight: 5,
	},
});

const commonColumns = [
	{
		label: 'Station',
		sortId: 'stationNumber',
		displayId: 'stationDisplay',
	},
	{
		label: 'Sent To',
		sortId: 'sentToSort',
		displayId: 'sentTo',
	},
	{
		label: 'Date Sent',
		sortId: 'dateSent',
		displayId: 'dateSentFormatted',
	},
];

const triageColumns = [
	...commonColumns,

	{
		label: 'Freshness',
		sortId: 'freshnessSort',
		displayId: 'freshnessDisplay',
	},
	{
		label: 'Replies',
		sortId: 'replyCount',
		displayId: 'replyDisplay',
	},

	{
		label: 'Action',
		sortId: 'action',
		displayId: 'action',
	},
];
const pendingColumns = [
	...commonColumns,
	{
		label: 'Freshness',
		sortId: 'freshnessSort',
		displayId: 'freshnessDisplay',
	},
	{
		label: 'Replies',
		sortId: 'replyCount',
		displayId: 'replyDisplay',
	},
	{
		label: 'Action',
		sortId: 'action',
		displayId: 'action',
	},
];

const completeColumns = [
	...commonColumns,
	{
		sortId: 'gasBuddyPrice',
		displayId: 'gasBuddyPriceDisplay',
		label: 'Added Price',
	},
	{
		label: 'Replies',
		sortId: 'replyCount',
		displayId: 'replyDisplay',
	},
];

const invalidColumns = [
	...commonColumns,
	{
		sortId: 'invalidReason',
		displayId: 'invalidReason',
		label: 'Reason Invalid',
		style: { textAlign: 'center' },
		isNotSortable: true,
	},
];

TabContainer.propTypes = {
	children: PropTypes.node.isRequired,
	dir: PropTypes.string.isRequired,
};

function TabContainer({ children, dir }) {
	return (
		<Typography component="div" dir={dir}>
			{children}
		</Typography>
	);
}

class PricingRequests extends Component {
	constructor(props) {
		super(props);

		const startingTab = _.get(this.props, ['match', 'params', 'startingTab'], 'current');
		const startingTabIndex = { current: 0, issued: 1, invalid: 2 }[startingTab] || 0;

		this.state = {
			tabIndex: startingTabIndex,
			triageOrder: 'asc',
			triageOrderBy: 'dateCreated',
			pendingOrder: 'asc',
			pendingOrderBy: 'dateCreated',
			invalidOrder: 'asc',
			invalidOrderBy: 'dateCreated',
			completeOrder: 'asc',
			completeOrderBy: 'dateCreated',
			search: '',
			isResourcePopupOpen: false,
			resourceIdsPoppedUp: [],
			commentPopoverAnchor: undefined,
			popoverComment: '',
			isUnknownReplyOpen: false,
			isConfirmInvalidateOpen: false,
			isPriceSettingsOpen: false,
			isTestMultiSmsOpen: false,
		};
	}

	componentDidMount() {
		const {
			triagePricingRequests,
			pendingPricingRequests,
			completePricingRequests,
			invalidPricingRequests,
		} = this.props;
		const {
			triageOrder,
			triageOrderBy,
			pendingOrder,
			pendingOrderBy,
			invalidOrder,
			invalidOrderBy,
			completeOrder,
			completeOrderBy,
		} = this.state;

		const newState = {};

		if (!triagePricingRequests) {
			this.props.searchPricingRequests({
				status: 'triage',
			});
		} else {
			const data = this.formatPricingRequests({
				pricingRequests: this.props.triagePricingRequests,
				statusType: 'triage',
			});
			newState.triageRows = sortTable({ data, order: triageOrder, orderBy: triageOrderBy });
		}

		if (!pendingPricingRequests) {
			this.props.searchPricingRequests({
				status: 'pending',
				afterDate: moment().subtract(DAYS_BACK_TO_SEARCH, 'days').format('YYYY-MM-DD'),
			});
		} else {
			const data = this.formatPricingRequests({
				pricingRequests: this.props.pendingPricingRequests,
				statusType: 'pending',
			});
			newState.pendingRows = sortTable({ data, order: pendingOrder, orderBy: pendingOrderBy });
		}

		if (!completePricingRequests) {
			this.props.searchPricingRequests({
				status: 'issued',
				afterDate: moment().subtract(DAYS_BACK_TO_SEARCH, 'days').format('YYYY-MM-DD'),
			});
		} else {
			const data = this.formatPricingRequests({
				pricingRequests: this.props.completePricingRequests,
				statusType: 'issued',
			});
			newState.completeRows = sortTable({ data, order: completeOrder, orderBy: completeOrderBy });
		}

		if (!invalidPricingRequests) {
			this.props.searchPricingRequests({
				status: 'invalid',
				afterDate: moment().subtract(DAYS_BACK_TO_SEARCH, 'days').format('YYYY-MM-DD'),
			});
		} else {
			const data = this.formatPricingRequests({
				pricingRequests: this.props.invalidPricingRequests,
				statusType: 'invalid',
			});
			newState.invalidRows = sortTable({ data, order: invalidOrder, orderBy: invalidOrderBy });
		}

		if (!_.isEmpty(_.keys(newState))) {
			this.setState(newState);
		}
	}

	componentDidUpdate(prevProps, prevState) {
		const {
			triageOrder,
			triageOrderBy,
			pendingOrder,
			pendingOrderBy,
			invalidOrder,
			invalidOrderBy,
			completeOrder,
			completeOrderBy,
		} = this.state;

		const newState = {};

		//- Format the rows when you first get them or they change
		if (prevProps.triagePricingRequests !== this.props.triagePricingRequests) {
			const data = this.formatPricingRequests({
				pricingRequests: this.props.triagePricingRequests,
				statusType: 'triage',
			});
			newState.triageRows = sortTable({ data, order: triageOrder, orderBy: triageOrderBy });
		}

		if (prevProps.pendingPricingRequests !== this.props.pendingPricingRequests) {
			const data = this.formatPricingRequests({
				pricingRequests: this.props.pendingPricingRequests,
				statusType: 'pending',
			});
			newState.pendingRows = sortTable({ data, order: pendingOrder, orderBy: pendingOrderBy });
		}

		//- Format the rows when you first get them or they change
		if (prevProps.invalidPricingRequests !== this.props.invalidPricingRequests) {
			const data = this.formatPricingRequests({
				pricingRequests: this.props.invalidPricingRequests,
				statusType: 'invalid',
			});
			newState.invalidRows = sortTable({ data, order: invalidOrder, orderBy: invalidOrderBy });
		}

		if (prevProps.completePricingRequests !== this.props.completePricingRequests) {
			const data = this.formatPricingRequests({
				pricingRequests: this.props.completePricingRequests,
			});
			newState.completeRows = sortTable({ data, order: completeOrder, orderBy: completeOrderBy });
		}

		//- Sort
		if (prevState.triageOrder !== triageOrder || prevState.triageOrderBy !== triageOrderBy) {
			newState.triageRows = sortTable({
				data: this.state.triageRows,
				order: triageOrder,
				orderBy: triageOrderBy,
			});
		}

		if (prevState.pendingOrder !== pendingOrder || prevState.pendingOrderBy !== pendingOrderBy) {
			newState.pendingRows = sortTable({
				data: this.state.pendingRows,
				order: pendingOrder,
				orderBy: pendingOrderBy,
			});
		}

		if (prevState.invalidOrder !== invalidOrder || prevState.invalidOrderBy !== invalidOrderBy) {
			newState.invalidRows = sortTable({
				data: this.state.invalidRows,
				order: invalidOrder,
				orderBy: invalidOrderBy,
			});
		}

		if (
			prevState.completeOrder !== completeOrder ||
			prevState.completeOrderBy !== completeOrderBy
		) {
			newState.completeRows = sortTable({
				data: this.state.completeRows,
				order: completeOrder,
				orderBy: completeOrderBy,
			});
		}

		if (!_.isEmpty(_.keys(newState))) {
			this.setState(newState);
		}
	}

	handleCommentPopoverOpen = (event, internalNote) => {
		this.setState({
			popoverComment: internalNote,
			commentPopoverAnchor: event.currentTarget,
		});
	};
	handleCommentPopoverClose = () => {
		this.setState({ commentPopoverAnchor: null });
	};

	replyStatusToIcon = (status) => {
		const { classes } = this.props;
		if (status === 'matched') {
			return <span className={classes.greenCheckedIconSmall} />;
		} else {
			return <span className={classes.errorIconSmall} />;
		}
	};

	formatPricingRequests = ({ pricingRequests, statusType }) => {
		const { classes, stationMap, userMap, gasBuddyPriceMap } = this.props;
		// const { classes, stationMap, userMap } = this.props;
		const ret = [];
		const isPending = statusType === 'pending';
		const isTriage = statusType === 'triage';

		const now = moment();
		pricingRequests.forEach((pricingRequest) => {
			const {
				pricingRequestId,
				createdByUserId,
				stationId,
				multiStationIds,
				dateCreated,
				sendSource,
				status,
				invalidReason,
				sentToMobileNumber,
				sentToRecipient,
				sentMessage,
				replies,
				createdGasBuddyPriceId,
			} = pricingRequest;

			let stationDisplay = '';
			let stationNumber = '';

			if (multiStationIds) {
				const stationLines = [];
				multiStationIds.forEach((stationId) => {
					const station = stationMap[stationId] || { number: 'Missing' };
					stationNumber = station.number;
					stationLines.push(`${station.number} - ${station.name}`);
				});
				stationDisplay = (
					<div>
						{stationLines.map((line) => (
							<div key={line}>{line}</div>
						))}
					</div>
				);
			} else {
				const station = stationMap[stationId] || { number: 'Missing' };
				stationNumber = station.number;
				stationDisplay = `${station.number} - ${station.name}`;
			}

			const user = userMap[createdByUserId] || { firstName: 'Automatic' };

			let replyDisplay = 'none yet';
			if (!_.isEmpty(replies)) {
				replyDisplay = (
					<div>
						{replies.map((reply) => {
							return (
								<div key={reply.dateCreated}>
									<div className={classes.replyDate}>
										{sentToMobileNumber} @{moment(reply.dateCreated).format('M/D/YY h:mm a')}
									</div>

									<div className={classes.replyMessage}>
										<div style={{ whiteSpace: 'pre-wrap' }}>{reply.message}</div>
										<div
											className={classes.replyStatus}
											onMouseEnter={(event) => {
												this.handleCommentPopoverOpen(event, reply.statusMessage);
											}}
											onMouseLeave={this.handleCommentPopoverClose}
										>
											{this.replyStatusToIcon(reply.status)}
										</div>
									</div>
								</div>
							);
						})}
					</div>
				);
			}

			const dateCreatedMoment = moment(dateCreated);
			const freshnessSort = now.diff(dateCreatedMoment);
			const freshnessHuman = moment.duration(now.diff(dateCreatedMoment)).humanize();

			const freshnessInHours = now.diff(dateCreatedMoment, 'hours');
			const freshnessColor = freshnessToColorHsl(freshnessInHours);

			const freshnessDisplay = (
				<div>
					<div
						className={classes.freshnessColor}
						style={{
							backgroundColor: freshnessColor,
						}}
					/>
					{freshnessHuman}
				</div>
			);

			let gasBuddyPriceDisplay = '-';
			if (createdGasBuddyPriceId) {
				const gasBuddyPrice = gasBuddyPriceMap[createdGasBuddyPriceId];
				let priceSource = '';
				if (gasBuddyPrice.createdByUserId) {
					const user = userMap[gasBuddyPrice.createdByUserId] || { firstName: 'missing' };
					priceSource = user.firstName;
				} else if (gasBuddyPrice.inputSource === 'MULTI-SITE') {
					priceSource = 'FMP Multi-site';
				} else {
					priceSource = 'FMP AutoParse';
				}

				gasBuddyPriceDisplay = (
					<div>
						<div>
							<strong style={{ fontSize: 18 }}>${gasBuddyPrice.gasBuddyPrice}</strong>
						</div>
						<div style={{ fontSize: 12, color: '#999' }}>(Source: {priceSource})</div>
					</div>
				);
			}

			const row = {
				key: pricingRequestId,
				dateSentFormatted: (
					<div>
						<div>{moment(dateCreated).format('dddd, M/D/YY h:mm a')}</div>
						<div>Sent By: {sendSource === 'AutoSMS' ? sendSource : user.firstName}</div>
					</div>
				),
				stationNumber,
				stationDisplay,
				status,
				sentTo: (
					<div>
						<div>{sentToMobileNumber}</div>
						<div>{sentToRecipient}</div>
					</div>
				),
				replyCount: isEmpty(replies) ? 0 : replies.length,
				replyDisplay,
				sentMessage,
				sentBy: user.firstName,
				invalidReason,
				freshnessSort,
				freshnessDisplay,
				gasBuddyPriceDisplay,
			};

			if (isPending) {
				row.action = (
					<div>
						<Button
							className={classes.button}
							onClick={() => this.handleInvalidate(pricingRequestId)}
						>
							Mark Invalid
						</Button>
					</div>
				);
			} else if (isTriage) {
				row.action = (
					<div>
						<Button className={classes.button} onClick={() => this.handleTriage(pricingRequestId)}>
							Triage
						</Button>
					</div>
				);
			}

			ret.push(row);
		});
		return ret;
	};

	handleSearch = (event) => {
		this.setState({ search: event.target.value });
	};

	handleTriage = (pricingRequestId) => {
		this.props.history.push(`/retailPricing/triagePricingRequest/${pricingRequestId}`);
	};

	handleDocClick = (resourceId) => {
		this.setState({
			resourceIdsPoppedUp: [resourceId],
			isResourcePopupOpen: true,
		});
	};

	handleCloseResourcePopup = () => {
		this.setState({
			isResourcePopupOpen: false,
			resourceIdsPoppedUp: [],
		});
	};

	handleTabChange = (event, tabIndex) => {
		this.setState({ tabIndex });
	};

	handleChangeTabIndex = (index) => {
		this.setState({ tabIndex: index });
	};

	handleOpenUnknownReply = () => {
		this.setState({ isUnknownReplyOpen: true });
	};
	handleOpenPriceSettings = () => {
		this.setState({ isPriceSettingsOpen: true });
	};

	handleOpenMultiSiteSms = () => {
		this.setState({ isTestMultiSmsOpen: true });
	};

	handleCloseUnknownReply = () => {
		this.setState({ isUnknownReplyOpen: false });
	};
	handleClosePriceSettings = () => {
		this.setState({ isPriceSettingsOpen: false });
	};
	handleCloseTestMultiSms = () => {
		this.setState({ isTestMultiSmsOpen: false });
	};

	handleInvalidate = (pricingRequestIdToInvalidate) => {
		this.setState({ isConfirmInvalidateOpen: true, pricingRequestIdToInvalidate });
	};

	closeInvalidateDialog = () => {
		this.setState({ isConfirmInvalidateOpen: false, pricingRequestIdToInvalidate: undefined });
	};

	render() {
		const { classes, theme } = this.props;

		const {
			triageRows = [],
			pendingRows = [],
			completeRows = [],
			invalidRows = [],
			triageOrder,
			triageOrderBy,
			pendingOrder,
			pendingOrderBy,
			invalidOrder,
			invalidOrderBy,
			completeOrder,
			completeOrderBy,
		} = this.state;

		if (!pendingRows) {
			return <div>Loading pricing request ...</div>;
		}
		return (
			<Grid container spacing={3}>
				<Grid item xs={12}>
					<Grid container spacing={3}>
						<Grid item xs={12}>
							<Typography
								variant="h5"
								align="left"
								gutterBottom
								className={classes.title}
								style={{ display: 'flex', justifyContent: 'space-between' }}
							>
								<span>Pricing Requests</span>
								<div>
									<Button
										variant="outlined"
										onClick={this.handleOpenPriceSettings}
										style={{ marginRight: 10 }}
									>
										Change Price Settings
									</Button>
									<Button
										variant="outlined"
										onClick={this.handleOpenUnknownReply}
										style={{ marginRight: 10 }}
									>
										View Unknown Replies
									</Button>

									<Button variant="outlined" onClick={this.handleOpenMultiSiteSms}>
										Test Multi-Site SMS
									</Button>
								</div>
							</Typography>
						</Grid>
					</Grid>

					<AppBar position="static" color="default">
						<Tabs
							value={this.state.tabIndex}
							onChange={this.handleTabChange}
							indicatorColor="primary"
							textColor="primary"
							variant="fullWidth"
							centered
						>
							<Tab label="Needs Triage" icon={<TriageIcon />} />
							<Tab label="Pending Reply" icon={<PendingIcon />} />
							<Tab label="Prices Added" icon={<PriceGoodIcon />} />
							<Tab label="Invalid / Ignored" icon={<InvalidIcon />} />
						</Tabs>
					</AppBar>
					<Paper className={classes.paper}>
						<SwipeableViews
							axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
							index={this.state.tabIndex}
							onChangeIndex={this.handleChangeTabIndex}
						>
							<TabContainer dir={theme.direction}>
								{isEmpty(triageRows) && (
									<div style={{ fontStyle: 'italic', color: '#999' }}>
										No pricing requests to currently triage
									</div>
								)}
								{!isEmpty(triageRows) && (
									<EnhancedTable
										columns={triageColumns}
										rows={triageRows}
										defaultOrder={triageOrder}
										defaultOrderBy={triageOrderBy}
									/>
								)}
							</TabContainer>
							<TabContainer dir={theme.direction}>
								{isEmpty(pendingRows) && (
									<div style={{ fontStyle: 'italic', color: '#999' }}>
										No pending pricing requests
									</div>
								)}

								{!isEmpty(pendingRows) && (
									<EnhancedTable
										columns={pendingColumns}
										rows={pendingRows}
										defaultOrder={pendingOrder}
										defaultOrderBy={pendingOrderBy}
									/>
								)}
							</TabContainer>
							<TabContainer dir={theme.direction}>
								{isEmpty(completeRows) && (
									<div style={{ fontStyle: 'italic', color: '#999' }}>
										No recently completed pricing requests
									</div>
								)}
								{!isEmpty(completeRows) && (
									<EnhancedTable
										columns={completeColumns}
										rows={completeRows}
										defaultOrder={completeOrder}
										defaultOrderBy={completeOrderBy}
									/>
								)}
							</TabContainer>
							<TabContainer dir={theme.direction}>
								{isEmpty(invalidRows) && (
									<div style={{ fontStyle: 'italic', color: '#999' }}>
										No recently invalidated pricing requests.
									</div>
								)}
								{!isEmpty(invalidRows) && (
									<EnhancedTable
										columns={invalidColumns}
										rows={invalidRows}
										defaultOrder={invalidOrder}
										defaultOrderBy={invalidOrderBy}
									/>
								)}
							</TabContainer>
						</SwipeableViews>

						<UnknownPricingRepliesDialog
							open={this.state.isUnknownReplyOpen}
							onClose={this.handleCloseUnknownReply}
							showErrors={this.props.showErrors}
						/>

						<PriceSettingsDialog
							open={this.state.isPriceSettingsOpen}
							onClose={this.handleClosePriceSettings}
							showErrors={this.props.showErrors}
						/>

						<TestMultiSmsDialog
							open={this.state.isTestMultiSmsOpen}
							onClose={this.handleCloseTestMultiSms}
							showErrors={this.props.showErrors}
						/>

						<ConfirmInvalidatePricingRequest
							open={this.state.isConfirmInvalidateOpen}
							onClose={this.closeInvalidateDialog}
							pricingRequestId={this.state.pricingRequestIdToInvalidate}
							invalidatePricingRequest={this.props.invalidatePricingRequest}
							showErrors={this.props.showErrors}
							history={this.props.history}
						/>

						<Popover
							id="comment-popover"
							className={classes.popover}
							classes={{ paper: classes.popOverPaper }}
							open={!!this.state.commentPopoverAnchor}
							anchorEl={this.state.commentPopoverAnchor}
							anchorOrigin={{
								vertical: 'bottom',
								horizontal: 'left',
							}}
							transformOrigin={{
								vertical: 'top',
								horizontal: 'left',
							}}
							onClose={this.state.handleCommentPopoverClose}
							disableRestoreFocus
						>
							<div className={classes.commentsContainer}>
								{!!this.state.popoverComment && <div>{this.state.popoverComment}</div>}
							</div>
						</Popover>
					</Paper>
				</Grid>
			</Grid>
		);
	}
}

PricingRequests.propTypes = {
	classes: PropTypes.object.isRequired,
	searchPricingRequests: PropTypes.func.isRequired,
	invalidatePricingRequest: PropTypes.func.isRequired,
	triagePricingRequests: PropTypes.array,
	pendingPricingRequests: PropTypes.array,
	invalidPricingRequests: PropTypes.array,
	completePricingRequests: PropTypes.array,

	showErrors: PropTypes.func.isRequired,

	userMap: PropTypes.object,
	stationMap: PropTypes.object,
	gasBuddyPriceMap: PropTypes.object,

	history: PropTypes.object,
	theme: PropTypes.object.isRequired,
	authUser: PropTypes.object,
};

export default _.flow([
	withStyles(styles, { withTheme: true }),
	AuthUserContainer,
	PricingRequestsContainer,
])(PricingRequests);
